import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

// Bidirectional internal linking: surfaces blog guides anchored to this
// medication/ingredient on its SEO hub page (topical cluster for SEO + GEO).
export function RelatedGuides({ anchorType, anchorId, title = "Related guides" }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    if (!anchorType || !anchorId) return;
    api
      .get(`/blog/for-anchor/${anchorType}/${anchorId}`)
      .then((r) => setPosts(r.data.posts || []))
      .catch(() => setPosts([]));
  }, [anchorType, anchorId]);

  if (!posts.length) return null;

  return (
    <section
      data-testid="related-guides"
      className="pt-6 border-t border-surface-line"
    >
      <div className="flex items-center gap-2">
        <BookOpen className="w-4 h-4 text-[#1f3d2e]" />
        <h2 className="text-lg font-bold text-ink">{title}</h2>
      </div>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {posts.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            data-testid={`related-guide-${p.slug}`}
            className="group flex items-start justify-between gap-3 rounded-xl border border-surface-line bg-white p-4 hover:shadow-card transition-all hover:-translate-y-0.5"
          >
            <div className="min-w-0">
              <span className="text-[10.5px] uppercase tracking-[0.16em] font-bold text-ink-mute">
                {p.category_label}
              </span>
              <p className="mt-1 text-[14px] font-semibold text-ink leading-snug line-clamp-2">
                {p.title}
              </p>
            </div>
            <ArrowRight className="w-4 h-4 text-ink-mute shrink-0 mt-0.5 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        ))}
      </div>
    </section>
  );
}
